import { clone, randomString } from "./tool";

const icons = [
  {
    title: "报名",
    type: 7,
    // icon: "icon-list",
    funcText: "报名",
    img:
      "https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/16935628349913FpMaCjex2YpYN8BKeNpNWe8jz7xitiw.png",
  },
  {
    title: "外链",
    type: 3,
    // icon: "icon-link",
    funcText: "外链",
    img:
      "https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/1693562823962ZxwfWPRAKGPTra4xbcBz6DtjTKeHtSfd.png",
  },
  {
    title: "活动日程",
    type: 5,
    // icon: "icon-article",
    funcText: "活动日程",
    img:
      "https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/1693562787270fHHcThQ3TsQxWDxWH553A8mcRkJQFbyy.png",
  },
  {
    title: "文件下载",
    type: 4,
    // icon: "icon-date",
    funcText: "文件下载",
    img:
      "https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/16935627724346dKN7PCcwnBbbnZDszDtZRfBzFz65hQ3.png",
  },
  {
    title: "活动文章",
    type: 2,
    // icon: "icon-hotel",
    funcText: "活动文章",
    img:
      "https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/1693562756662hTt2J4JfDJGc2GA3e2zikmBQ77M8FrBf.png",
  },
  {
    title: "直播视频",
    type: 6,
    // icon: "icon-enroll",
    funcText: "直播视频",
    img:
      "https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/169356273901283nNxDpNYh7WCWfcex3wENYD2xKE5cW6.png",
  },
  {
    title: "列表",
    type: 1,
    // icon: "icon-home",
    funcText: "列表",
    img:
      "https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/1693562726757yDMDciw4y6EyGeMRp7dSPWcXmnSZZeTy.png",
  },
  {
    title: "会议论坛",
    type: 9,
    // icon: "icon-home",
    funcText: "会议论坛",
    img:
        "https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/1693562726757yDMDciw4y6EyGeMRp7dSPWcXmnSZZeTy.png",
  },
  {
    title: "人才杭州",
    type: 11,
    // icon: "icon-home",
    funcText: "人才杭州",
    img:
        "https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/1693562726757yDMDciw4y6EyGeMRp7dSPWcXmnSZZeTy.png",
  },
  {
    title: "交通导览",
    type: 12,
    // icon: "icon-home",
    funcText: "交通导览",
    img:
        "https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/1693562726757yDMDciw4y6EyGeMRp7dSPWcXmnSZZeTy.png",
  },
  {
    title: "酒店",
    type: 13,
    // icon: "icon-home",
    funcText: "酒店",
    img:
        "https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/1726830798032d6NP3T4jCC4ibQtkby6YrTtSNRC76WFR.png",
  },
  // {
  //   title: "个人中心",
  //   type: 8,
  //   // icon: "icon-person",
  //   funcText: "个人中心",
  //   img:
  //     "https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/1676882316666QyiW3t5y4xwybfSt6rkKKnkMBYzQNKhy.png",
  // },
];

const getIcons = function() {
  let temp = clone(icons);
  temp.forEach((item) => {
    item.key = `icon_${randomString(6)}`;
    item.color = "";
    item.textColor = "#000000";
  });
  return temp;
};

export { getIcons };

export default icons;
